import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDynamicPricingStore } from '../store/dynamic-pricing-store';
import type { DynamicPricingTab } from '../types/dynamic-pricing.types';

/**
 * Las piezas que Compite reutiliza de Precios Dinámicos cambian de pestaña con
 * el store (`setActiveTab('monitoring')`, «ver productos vinculados con esta
 * tienda»). En Compite cada pestaña vieja vive en una ruta: esto traduce el
 * cambio a la ruta equivalente, sin tocar esos componentes.
 */
export function rutaDeLaPestana(
  pestana: DynamicPricingTab,
  extra: { tiendaDeProductos?: string | null } = {}
): string {
  switch (pestana) {
    case 'overview':
      return '/compite/monitoreo?tab=cambios';
    case 'products':
      return extra.tiendaDeProductos
        ? `/compite/monitoreo?tab=productos&tienda=${encodeURIComponent(extra.tiendaDeProductos)}`
        : '/compite/monitoreo?tab=productos';
    case 'competitors':
      return '/compite/competencia';
    case 'charts':
      return '/compite/analitica';
    case 'catalog':
      return '/compite/productos?tab=catalogo';
    case 'inference':
      return '/compite/productos?tab=vincular';
    case 'monitoring':
      return '/compite/competencia?tab=lecturas';
    case 'api':
      return '/claves-api';
  }
}

/** Mientras la vista está montada, un cambio de pestaña del store navega a su ruta. */
export function usePuenteDePestanas() {
  const navigate = useNavigate();
  useEffect(
    () =>
      useDynamicPricingStore.subscribe((estado, antes) => {
        if (estado.activeTab === antes.activeTab) return;
        navigate(
          rutaDeLaPestana(estado.activeTab, {
            tiendaDeProductos: estado.productsPrefilter?.storeId,
          })
        );
      }),
    [navigate]
  );
}
